import { getSiteDomain } from 'utils/common';

const getWeatherUrl = (isPrimeUser = false) => {
  const PRIME_WEATHER_URL = `${getSiteDomain()}/toiignorevp/forecast_weathertoday_ext.cms`;
  const NON_PRIME_WEATHER_URL = `${getSiteDomain()}/forecast_weathertoday_ext.cms`;
  return isPrimeUser ? PRIME_WEATHER_URL : NON_PRIME_WEATHER_URL;
};

const iconsMap = {
  '0': 'tornado',
  '1': 'tropicalstrom',
  '2': 'hurricane',
  '3': 'cloudyheavythundershower',
  '4': 'cloudyheavythundershower',
  '5': 'raintosnowshowers',
  '6': 'rainsleet',
  '7': 'wintrymixsnowsleet',
  '8': 'freezingdrizzle',
  '9': 'cloudylightrain', //for night: overcastlightrain
  '10': 'freezingrain',
  '11': 'cloudylightrain', // for night: overcastlightrain
  '12': 'cloudyrain', // for night: overcastrain
  '13': 'cloudysnow', // for night: overcastsnow
  '14': 'cloudysnow', // for night : overcastsnow
  '15': 'blowingdriftingsnow',
  '16': 'cloudysnow', // for night: overcastsnow
  '17': 'hail',
  '18': 'sleet',
  '19': 'partlycloudyduststorm',
  '20': 'foggy',
  '21': 'hazy',
  '22': 'hazy',
  '23': 'breezy',
  '24': 'blowingspraywindy',
  '25': 'frigidicecrystals',
  '26': 'cloudy',
  '27': 'overcast', // for night: overcast
  '28': 'cloudy', // for night: overcast
  '29': 'overcast', // night
  '30': 'partlycloudy', // day
  '31': 'clearsky', // night
  '32': 'sunny', // day
  '33': 'clearsky',
  '34': 'clearsky',
  '35': 'mixedrainhail',
  '36': 'sunny',
  '37': 'cloudymoderatethundershower', // day
  '38': 'partlycloudymoderatethundershower',
  '39': 'overcastrain',
  '40': 'overcastheavyrain',
  '41': 'partlycloudysnow',
  '42': 'overcastsnow', //night
  '43': 'overcastsnow', // night
  '44': 'NA',
  '45': 'overcastrain',
  '46': 'overcastsnow',
  '47': 'overcastmoderatethundershower',
};

export { iconsMap, getWeatherUrl };
